module.exports = __webpack_public_path__ + "static/media/powerquery.fa5c461e.svg";